import type { FaireProductEntity } from "../../entity_types/product";

export const p_e91d9n0r8c: FaireProductEntity = {
  token: "p_e91d9n0r8c",
  type: "product",
  name: "Astroverse Catstronaut Slow-Rise Squishy Ball",
  brandToken: "b_83nqde8ah7",
  brandName: "Toysmith",
  imageUrl:
    "https://cdn.faire.com/fastly/ea95d4c222fd45b268d02839adc95cb2288b7eaac55737876f3051b266a94349.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7375370de40000ccb4d8914f2b5a1100e100afdf6d729cc8af7f91b79ac7c6ab.jpeg",
    "https://cdn.faire.com/fastly/004e3b115f2f8b9e37621e3d6f77b72ae6385a60aa083c1086ed6a5df7eff4ae.jpeg",
    "https://cdn.faire.com/fastly/deb9868d6b452fd5150998b37559e1ccdb5caa4683e07a7db6d27e8829969c99.jpeg",
    "https://cdn.faire.com/fastly/34e3a59026fa3ae81e06083363ebfa17a32d941941b20931ac49e40e2dd2d635.jpeg",
    "https://cdn.faire.com/fastly/d2a8ef3a2a0fee1b60d57d3d4a2583220a9092bf5b17dce6c6f4395a00f480ed.jpeg",
    "https://cdn.faire.com/fastly/ba57693aaf921029cc121fd9966d386b0aa659a90b28c617869a8f5abafdada3.jpeg",
  ],
  priceDollars: 4,
  description:
    "The Astroverse Catstronaut Slow-Rise Squishy Ball features an adorable, realistic kitty astronaut with big round eyes. Its small size and soft material also make it ideal for working on grip strength, dexterity, mobility, and fine and gross motor skills. 3.36-inch diameter squishy PU foam material. Compact size makes it easy to carry around or give as a fun gift or party favor.\r\n\r\n• Age Grade: 3+\r\n• Product Dimensions/Weight: 6.0 L x 3.0 W x 9.0 H / 0.2 lb\r\n• Inner Pack Dimensions/Weight: 16.1 L x 8.8 W x 6.5 H / 1.8 lb\r\n• Made In: China\r\n• Batteries not required",
  tags: [],
  msrpDollars: 7.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:58:40.019Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
